export default __webpack_public_path__ + "static/media/E.d1bc844f.svg";